<template>
  <div class="c-upload">
    <h2>{{ title }}</h2>
    <file-upload
      name="field1"
      @uploaded="onFileUploaded"
      @changeFile="onFileChange"
      resource="content1"
      :bypassDuplicate="true"
      :fileTypes="fileTypes"
      :multiple="multiple"
    ></file-upload>

    <ol class="c-upload__list">
      <li v-for="file in localFiles" :key="file" class="c-upload__list__item">
        {{ file.name }} uploaded
        <base-button
          type="button"
          @click="removeFile(file)"
          class="c-gallery__list-item__control danger"
          danger
          square
          inline
        >
          remove
        </base-button>
      </li>
    </ol>
  </div>
</template>

<script>
import FileUpload from "@/components/FileUpload";

export default {
  name: "media-file-upload",

  components: {
    FileUpload,
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    file_types: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fileTypes() {
      if (!this.file_types) {
        return null;
      }
      return this.file_types.replace(/\./g, "").split(",");
    },
    localFileIds() {
      if (this.localFiles.length > 0) {
        return this.localFiles.map(file => file.id)
      }
      return [];
    }
  },

  data() {
    return {
      resourceTitle: "",
      resourceId: "",
      resourceObject: {},
      resourceInfo: {},
      localFiles: [],
    };
  },

  created() {
    const { fileLink, title, $store } = this;
    if (this.fileId) {
      this.$store.dispatch("files/read", this.fileId).then((resp) => {
        const fileLinkClone = {
          id: resp.self,
          name: resp.name,
          documentId: resp.id,
          type: "file",
        };
        //   const fileLinkClone = {"id":"file/14","name":"Consultant Study & Proffesional Leave Form.doc","documentId":14,"type":"file"}
        this.resourceObject = fileLinkClone;
        this.resourceTitle = title ? title : this.resourceObject.name;

        console.log("rsp", this.resourceTitle);
      });
    } else if (fileLink) {
      this.resourceObject = JSON.parse(fileLink);
      this.resourceTitle = title || this.resourceObject.name;
    } else {
      this.resourceObject = {};
      this.resourceTitle = "";
    }
  },

  methods: {
    removeFile(fileid) {
      this.localFiles = this.localFiles.filter((file) => file != fileid);
      this.$emit("input", this.localFileIds);
    },
    onFileUploaded(val) {
      this.localFiles.push(val);
      this.forceUpload = false;
      this.$emit("input", this.localFileIds);
    },
    onFileChange() {
      // if we are a single upload, we need to remove the file that is there
      if (!this.multiple) {
        this.localFiles = [];
        this.$emit("input", this.localFileIds);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.c-upload {
  &__list {
    display: inline-flex;
    flex-direction: column;
    margin: 0;
    padding: 0;

    &__item {
      align-items: center;
      background: linear-gradient($colour-nhs-white, $colour-nhs-pale-grey);
      border: 2px solid $colour-nhs-mid-grey;
      display: inline-flex;
      gap: 10px;
      justify-content: space-between;
      padding: 5px;

      &:first-of-type {
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
      }
      &:last-of-type {
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
      }

      & + .c-upload__list__item {
        border-top: 0;
      }
    }
  }
}
</style>
